<div class="calendrier-wrapper">
	<app-calendrier-header
			[dateActuelleCalendrier]="dateActuelle()"
			(eventChangerDeDate)="changerDeMois($event)"/>
	<div class="calendrier-content">
		@if (loadingCalendrier()) {
			<div class="spinner">
				<div class="app-spinner"></div>
			</div>
		} @else {
			<div class="label-jours-semaine-full label-semaine-container" [ngClass]="{'semaine7jours': this.estSemaine7jours(), 'semaine5jours': this.estSemaine5jours()}">
				@for (labelJour of labelJoursComplet; track labelJour) {
					<span>{{ labelJour }}</span>
				}
			</div>
			<div class="label-jours-semaine-short label-semaine-container" [ngClass]="{'semaine7jours': this.estSemaine7jours(), 'semaine5jours': this.estSemaine5jours()}">
				@for (labelJour of labelJoursAbreviation; track labelJour) {
					<span>{{ labelJour }}</span>
				}
			</div>
			<div class="calendrier-semaines" [ngClass]="'nombre-semaine-' + nombreSemaines()">
				@for (semaine of semaines(); track semaine) {
					<div class="semaine" [ngClass]="{'semaine7jours': this.estSemaine7jours(), 'semaine5jours': this.estSemaine5jours()}">
						@for (jour of semaine.jours; track jour) {
							<div class="jour">
								<div class="header-jour-container">
									@if (estJourneePossedeTauxOccupation(jour)) {
										<div class="container-vide-taux-occupation"></div>
									}
									@if (estJourneeAvecBureauPreferentiel(jour)) {
										<div class="container-vide-bureau-preferentiel"></div>
									}
									<div class="date-du-jour">
										<div class="date-du-jour-container" [ngClass]="determinerClasseNumeroJour(jour)">
											{{ jour.getDate() }}
										</div>
									</div>
									@if (estJourneeAvecBureauPreferentiel(jour)) {
										<div class="place-preferentielle-indicateur">
											@if (loadingJourneeBureauPreferentiel()) {
												<p-progressSpinner
														strokeWidth="5"
														fill="transparent"
														animationDuration=".5s"/>
											} @else {
												<i [className]="iconeBureauPreferentielSelonJour(jour)"
												   style="font-size: 1.5rem"
												   (click)="onClickVoirEtatZoneDeTravail(jour)"
												   [pTooltip]="tooltipIconeBureauPreferentiel(jour)"></i>
											}
										</div>
									}
									@if (estJourneePossedeTauxOccupation(jour)) {
										<div class="jauge-occupation-container">
											@if (loadingTauxOccupation()) {
												<p-progressSpinner
														strokeWidth="5"
														fill="transparent"
														animationDuration=".5s"/>
											} @else {
												<app-jauge-occupation
														[occupationZoneDeTravail]="recupererTauxOccupationPourJournee(jour)"
														[dateTauxOccupation]="jour"/>
											}
										</div>
									}
								</div>
								<div class="jour-container">
									<div class="card-information-calendrier">
										<app-journee-calendrier
												[evenementsCalendriers]="evenementsCalendrierParDate().get(transformerDateJourEnCle(jour)) ?? []"
												[date]="jour"
												[estPlageSelectionnee]="estPlageSelectionnee(jour)"
												[masquerReservation]="masquerReservations()"
												(notifierSelectionPlageDisponible)="selectionnerDeselectionnerPlageDisponible($event)"
												(notifierSelectionEvenement)="ouvrirDetailEvenementModal($event)"
												(notifierSelectionReservation)="ouvrirDetailReservationModal($event)"/>
									</div>
								</div>
							</div>
						}
					</div>
				}
			</div>
			@if (isNotNullOrUndefined(evenementSelectionne())) {
				<app-detail-evenement-modal
						[visible]="showDetailEvenementModal()"
						[evenement]="evenementSelectionne()"
						[langueUtilisateur]="utilisateurConnecte.langue"
						(visibleChange)="showDetailEvenementModal.set($event)"
						(notificationEvenementAnnule)="onAnnulerEvenementCalendrier($event)"/>
			}
			@if (isNotNullOrUndefined(reservationSelectionne())) {
				<app-detail-reservation-modal
						[visible]="showDetailReservationModal()"
						[reservation]="reservationSelectionne()"
						[langueUtilisateur]="utilisateurConnecte.langue"
						(visibleChange)="showDetailReservationModal.set($event)"
						(notificationReservationAnnule)="onAnnulerEvenementCalendrier($event)"/>
			}
		}
	</div>
</div>

@if (isNotNullOrUndefined(dateAnnulationEvenement())) {
	<app-information-conflit-modal
			[dateConflit]="dateAnnulationEvenement()"
			[visible]="showPopupInformationConflit()"
			(visibleChange)="onFermerPopupInformationConflit($event)"/>
}
